/*
--- 
description: FED Process
authors: 
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var BasicMaps = new Class(
{
	Extends: GoogleMaps,
	
	initialize: function(element, options) {
		this.parent(element, options);			 
	},
	
	process_rpc: function() {
		this.parent();
		var data = this.main_remote.get_data();
		//Log.log(data);
		this.map.setOptions( Object.merge({
														mapTypeControl: true,
														navigationControl: true,
														streetViewControl: true,
														panControl: true,
														zoomControlOptions: { style: google.maps.ZoomControlStyle.LARGE }
												 })
											 );
											 
		if (data.categories) {
			data.categories[0].places.each(function(place, i) {						
						var mark = this.create_marker(place, data);
						 
						this.markers.push(mark);
						var content = this.create_bubble_content(place);

						var b = this.create_bubble(mark, content);
						google.maps.event.addListener(mark.get_object(), 'click', function(){ 
																																				this.open_bubble(b, mark);
																																			}.bind(this));						
			}.bind(this));
		}	 
		
		this.bound_overlays();
	},
	
	create_bubble_content: function(place){
		return '<strong><a href='+ place.url +'>' + place.address + '</a></strong><br/>' + place.location;
	},
	
	create_bubble: function(mark, content){
		return new GoogleMaps.Bubble(this, mark, { content: content });
	},
	
	create_marker: function(place, data){
		return new GoogleMaps.Marker(this, {
																				lat: place.lat,
																				lng: place.lng,
																				icon: data.ini.markers_path+'marker.png'
																				});
	}, 
	
	open_bubble: function(b, mark){
		if(this.current_bubble){
			this.current_bubble.close();
		}
		this.current_bubble = b;
		b.open(this, mark);
		
		this.map.setCenter(new google.maps.LatLng(mark.options.lat, mark.options.lng));
	}
});